import { Button, Typography } from "@material-ui/core";
import React, { useContext, useState } from "react";
import "./Modal.css";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";

function LoinModal({ setLoginModalOpen, setModalOpen }) {
  const [credentials, setCredentials] = useState({
    email: undefined,
    password: undefined,
  });
  const { user, loading, error, dispatch } = useContext(AuthContext);
  const handleChange = (e) => {
    setCredentials((prv) => ({
      ...prv,
      [e.target.id]: e.target.value,
    }));
  };
  const handleClick = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });
    try {
      const res = await axios.post(
        "https://abc-backend.onrender.com/api/auth/login",
        credentials
      );
      dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
    } catch (error) {
      dispatch({ type: "LOGIN_FAILURE", payload: error.response.data });
    }
  };
  if (user) {
    setLoginModalOpen(false);
  }

  const handleRegisterMoadel = () => {
    setModalOpen(true);
    setLoginModalOpen(false);
  };
  return (
    <div className="modalBackground loginModalContainer">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <button
            onClick={() => {
              setLoginModalOpen(false);
            }}
          >
            X
          </button>
        </div>
        <div className="title">
          <h1>Login</h1>
        </div>
        <div className="subtitle">
          <p>Please enter your login details</p>
        </div>
        <div className="body">
          <div>
            <div className="modalInput">
              <div className="login_modal_label_input">
                <label htmlFor="">Work Email *</label>
                <input type="email" id="email" onChange={handleChange} />
              </div>
            </div>
            <div className="modalInput">
              <div className="login_modal_label_input">
                <label htmlFor="">Password *</label>
                <input type="password" id="password" onChange={handleChange} />
              </div>
            </div>
          </div>
        </div>
        <div className="signButtonBody">
          {error && (
            <span style={{ padding: "10px", color: "red" }}>
              {error.message}
            </span>
          )}
          <div className="login-btn">
            <Button onClick={handleClick} disabled={loading}>
              Login
            </Button>
          </div>
          <Typography variant="h5" className="forgotPassword">
            Forgot Password?
          </Typography>
        </div>
        <div className="footer">
          <button onClick={handleRegisterMoadel}>
            Dont have an account? Register here
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoinModal;
